<template>
  <div class="h5-container">
    <div class="header">
      <span class="hitems-icon-placeholder"></span>
    </div>
    <div class="content">
      <!-- <video
        class="video1"
        src="@/assets/videos/h5-video-1.mp4"
        autoplay
        muted
        playsinline
        webkit-playsinline
        v-show="h5Video1Visible"
        v-on:ended="handleVideoEnded"
      ></video>
      <video
        ref="h5Video2Ref"
        class="video2"
        src="@/assets/videos/h5-video-2.mp4"
        muted
        playsinline
        webkit-playsinline
        loop
      ></video> -->
      <img class="bg-img" src="@/assets/images/h5/img-bg.webp" alt="背景图" />
    </div>
    <div class="footer">
      <img class="logo" src="@/assets/images/h5-footer-logo.webp" alt="logo" />
      <span class="desc">微信扫码体验【造好物小程序】</span>
      <div class="btn" @click="modalVisible = true">去体验</div>
    </div>

    <div class="wx-mini-modal" v-if="modalVisible">
      <div class="content">
        <p class="text">截屏保存去微信扫码</p>
        <p class="text">体验「造好物」小程序完整功能</p>
        <img class="mini-qrcode" src="@/assets/images/wechat-qrcode.webp" alt="小程序" />
        <img class="logo" src="@/assets/images/img-zy.png" alt="logo" />
        <div class="close" @click="modalVisible = false">
          <span class="hitems-guanbi"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  defineOptions({ name: 'H5Component' })

  const modalVisible = ref(false)
  const h5Video1Visible = ref(true)
  const h5Video2Ref = ref<HTMLVideoElement>()

  const handleVideoEnded = () => {
    h5Video2Ref.value?.play()
    h5Video1Visible.value = false
  }
</script>

<style lang="stylus" scoped>
  @import './index.styl';
</style>
